export default __webpack_public_path__ + "static/redislide2-7e39d8b5ed2b3eaf6eddb141d9e20dca.jpg";